import repository from '@/utils/repository';

export default {
    searchMst003Info: (data) => {
        return repository.post('/move/postCommonMst003Info', {
            ...data
        });
    }
};
